angular.module('impactx.list').controller('ListCtrl', [
    '$scope',
    'dataGen',
    '$errorHandler',
    '$listCache',
    'selectedListItems',
    '$workspace',
    'ListPrintService',
    'TranslationService',
    'ListFilterService',
    ListController]);

function ListController($scope, dataGen, $errorHandler, $listCache, selectedListItems, $workspace, ListPrintService, TranslationService, ListFilterService) {
    var ctrl = this;

    selectedListItems.initSelectedItemsList($scope.metaData.id);
    $scope.selectedItems = [];
    $scope.rowCollection = [];
    $scope.displayCollection = [];
    $scope.actionsOpen = false;
    $scope.actionCtrl = $scope.metaData.ctrl;
    $scope.numberOfPages = {};
    $scope.printTrns = TranslationService.get("print");
    $scope.isFilterCollapsed = ListFilterService.persistentFiltersCollapsed;
    $scope.specialAutocompleteField = {};
    $scope.addFilterTrns = TranslationService.get('addFilter');

    if ($scope.metaData.totalList && $scope.metaData.singleList) {
        $scope.totalListToolTip = TranslationService.get($scope.metaData.totalList.translationKey);
        $scope.singleListToolTip = TranslationService.get($scope.metaData.singleList.translationKey);
    }

    $scope.hasDateFilter = $scope.metaData.hasDateFilter;
    if ($scope.hasDateFilter) {
        ctrl.needWatcherInitForDate = true;
    }

    if (!$scope.metaData.id) {
        $errorHandler.showErrors([{error: 'ERROR-1: No Id given.'}], [], [])
    }

    if (!$scope.metaData.rowTemplate) {
        $errorHandler.showErrors([{error: 'ERROR-2: No Row template given.'}], [], [])
    }

    if (!($scope.metaData.filtersTemplate)) {
        $scope.metaData.filtersTemplate = 'shared/list/templates/list.filters.tmpl.html';
    }

    if (!$scope.metaData.idColumn) {
        $scope.metaData.idColumn = 'id';
    }

    if (!$scope.metaData.params) {
        $scope.metaData.params = {};
    }

    $scope.getFirstSelectedItemId = selectedListItems.getFirstSelectedId;

    $scope.getFirstSelectedItem = selectedListItems.getFirstSelectedItem;

    $scope.getSelectedIdsWithTypes = selectedListItems.getSelectedIdsWithTypes;

    $scope.getSelectedIds = function () {
        return selectedListItems.getSelectedIds($scope.metaData.idColumn);
    };

    $scope.getSelectedIdsForLink = function () {
        return selectedListItems.getSelectedIds($scope.metaData.idColumn).toString().replace("[", "").replace("]", "");
    };

    $scope.getNumberOfSelectedItems = function () {
        return selectedListItems.getSelectedItems().length;
    };

    $scope.collapsePersistentListFilters = function () {
        ListFilterService.togglePersistentFilters();
    };

    $scope.getCurrentWorkspaceId = function () {
        return $workspace.getCurrentWorkspaceId().value;
    };

    ctrl.isActionAllowed = function (name) {
        var isActionAllowed = false;
        var action = ctrl.getAction(name);
        if (action) {
            isActionAllowed = action.allowed;
        }
        return isActionAllowed
    };

    ctrl.getActionLabel = function (name) {
        var label = "";
        var action = ctrl.getAction(name);
        if (action) {
            label = action.label;
        }
        return label
    };

    ctrl.getAction = function (name) {
        var action = null;
        var data = $scope.data;
        if (data) {
            var actions = data.actions;
            if (actions) {
                action = actions[name];
            }
        }
        return action;
    };

    function saveFilters() {
        $listCache.putFilters($scope.metaData.id, $scope.data.headers);
        if ($scope.hasDateFilter) {
            $listCache.putDateFilter($scope.metaData.id, $scope.data.dateFilterFields.timePeriod.selected.id);
        }
        $listCache.putPopupFilters($scope.metaData.id, $scope.data.popupFilters);
        $listCache.putBooleanFilters($scope.metaData.id, $scope.data.booleanFilters);
        $listCache.putAutocompleteFilters($scope.metaData.id, $scope.data.autoCompleteFilters);
        $listCache.putDeprecatedFilter($scope.metaData.id, $scope.data.deprecatedFilter);
        $listCache.putDateFilters($scope.metaData.id, $scope.data.dateFilters);
        $listCache.putSpecialAutocompleteField($scope.metaData.id, $scope.specialAutocompleteField);
    }

    $scope.$on("$destroy", function () {
        if ($scope.data) {
            saveFilters();
        }
    });

    ctrl.sidebarIsOpen = function () {
        return ListFilterService.isOpen();
    };

    $scope.onScroll = function (event, scrollTop) {
        var ngView = angular.element('ng-view');
        if (scrollTop > 0) {
            ngView.css("z-index", 1);
        }
        else {
            ngView.css('z-index', "");
        }
    };
}